var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Dialog from '@mui/material/Dialog/Dialog';
import { InputFieldType } from 'models/Input/InputModels';
import { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box/Box';
import { cpaService } from 'services/api/cpa-service';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton/IconButton';
import Typography from '@mui/material/Typography/Typography';
import { toUTCTimestamp } from 'services/helperFunctions/toUTCTimestamp';
import { useGetListPrice } from 'hooks/useGetListPrice';
import { useGetListPriceWithValidate } from 'hooks/useGetListPriceWithValidate';
import { Link } from 'react-router-dom';
import { InputFieldsContainer } from '../InputFieldsContainer/InputFieldsContainer';
import { inputFieldsContainerHelper } from '../InputFieldsContainer/InputFieldsContainerHelper';
import styles from './CpaQuickView.module.scss';
import { PubTable } from '../PubTable/PubTable';
import { LoadingSpinner } from '../Loading/LoadingSpinner/LoadingSpinner';
var PRODUCT_LINE_CODE_FIELD_NAME = 'productLineCode';
var STANDARD_PRODUCT_REF_FIELD_NAME = 'standardProductReference';
var DISCOUNT_CODE_FIELD_NAME = 'discountCode';
var DESCRIPTION_VALUE = 'descriptionValue';
var CPN_FIELD_NAME = 'cpn';
export function CpaQuickView(_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k;
    var isOpen = _a.isOpen, closeModal = _a.closeModal, cpn = _a.cpn, standardProductRef = _a.standardProductRef, productVersion = _a.productVersion, productId = _a.productId;
    var _l = useState(), cpaProduct = _l[0], setCpaProduct = _l[1];
    var _m = useState({}), fieldValues = _m[0], setFieldValues = _m[1];
    var _o = useState({}), featureTableData = _o[0], setFeatureTableData = _o[1];
    var _p = useState(true), isLoading = _p[0], setIsLoading = _p[1];
    var standardProductPrice = useGetListPrice(standardProductRef, cpn);
    var calculatedProductPrice = useGetListPriceWithValidate(cpn, cpn, true, false, false, true, 10);
    var todaysDate = new Date();
    var newParsedTimeStamp = toUTCTimestamp(todaysDate.toISOString());
    var keyPress = useCallback(function (e) {
        if (e.key === 'Escape') {
            closeModal();
        }
    }, [closeModal]);
    useEffect(function () {
        document.addEventListener('keyup', keyPress);
        return function () { return document.removeEventListener('keyup', keyPress); };
    }, [keyPress]);
    useEffect(function () {
        function fetchProduct() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var result, featureTableRow_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!cpn) return [3 /*break*/, 2];
                            return [4 /*yield*/, getCpaProduct(cpn)];
                        case 1:
                            result = _b.sent();
                            setCpaProduct(result.body.product);
                            featureTableRow_1 = [];
                            (_a = result.body.product.featureOptions) === null || _a === void 0 ? void 0 : _a.forEach(function (row, idx) {
                                featureTableRow_1.push(__assign(__assign({}, row), { rowNo: idx + 1 }));
                            });
                            setFeatureTableData(featureTableRow_1 || {});
                            _b.label = 2;
                        case 2:
                            setIsLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        fetchProduct();
    }, [cpn]);
    useEffect(function () {
        setFieldValues(buildFieldValues(cpaProduct, cpn));
    }, [cpaProduct, cpn]);
    var productInformationCols = {
        rowGap: '4px',
        title: { displayText: 'Product Information', marginBottom: '16px' },
        showActions: false,
        preventReadOnly: true,
        disabled: true,
        fields: (_b = {},
            _b[CPN_FIELD_NAME] = {
                fieldName: 'Custom Product Number:',
                displaySeq: 0,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[STANDARD_PRODUCT_REF_FIELD_NAME] = {
                fieldName: 'Standard Product Number:',
                displaySeq: 1,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                    validations: {
                        maxLength: 250,
                    },
                },
            },
            _b[PRODUCT_LINE_CODE_FIELD_NAME] = {
                fieldName: 'Product Line (Code):',
                displaySeq: 2,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[DISCOUNT_CODE_FIELD_NAME] = {
                fieldName: 'Discount (Code):',
                displaySeq: 3,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b[DESCRIPTION_VALUE] = {
                fieldName: 'Description:',
                displaySeq: 4,
                hasLookup: false,
                input: {
                    type: InputFieldType.READONLY,
                },
            },
            _b),
    };
    var priceHeaderCols = {
        rowGap: '4px',
        title: { displayText: 'Current Pricing', marginBottom: '16px' },
        showActions: false,
        fields: {
            stdProdPrice: {
                fieldName: 'Standard Product Price:',
                displaySeq: 0,
                input: {
                    type: InputFieldType.READONLY,
                },
                hasLookup: false,
            },
            calcProdPrice: {
                fieldName: 'Calculated Product Price:',
                displaySeq: 1,
                input: {
                    placeholderText: 'Add Price to see Calculated Product Price',
                    type: InputFieldType.READONLY,
                    informationalText: undefined,
                },
                hasLookup: false,
            },
        },
    };
    var tableDataDefinition = {
        rowDecorator: {
            value: 'DEVIATED',
            hide: function (row) { return !row.devInd; },
        },
        columns: [
            {
                dataAttribute: 'rowNo',
                fieldType: InputFieldType.NUMBER,
                heading: 'Row',
                width: '100px',
            },
            {
                dataAttribute: 'featureDescription',
                fieldType: InputFieldType.STRING,
                heading: 'Feature Name',
                width: '300px',
            },
            {
                dataAttribute: 'optionCode',
                fieldType: InputFieldType.STRING,
                heading: 'Option Code',
                width: '200px',
            },
            {
                dataAttribute: 'optionDescription',
                fieldType: InputFieldType.STRING,
                heading: 'Option Description',
            },
        ],
    };
    return (_jsxs(_Fragment, { children: [isLoading && (_jsx(Box, __assign({ className: styles.outerBox }, { children: _jsx(LoadingSpinner, { indicatorSize: 10 }) }))), !isLoading && (_jsxs(Dialog, __assign({ open: isOpen, onClose: closeModal, PaperProps: {
                    sx: {
                        width: '100%',
                        maxWidth: '75%',
                        '::-webkit-scrollbar-track': { background: 'transparent' },
                        scrollbarColor: '#acacac transparent',
                    },
                } }, { children: [_jsx(Box, __assign({ className: styles.cpaViewContainer }, { children: _jsxs(Box, __assign({ className: styles.container }, { children: [_jsx("h1", __assign({ className: styles.title }, { children: "Quick View" })), _jsx(IconButton, __assign({ "aria-label": "cpa quick view close", onClick: closeModal, sx: {
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                    } }, { children: _jsx(CloseIcon, {}) }))] })) })), _jsx("hr", { className: styles.hr }), _jsxs(Box, __assign({ className: styles.headerContainer }, { children: [_jsx(InputFieldsContainer, { colDef: productInformationCols, fieldValues: fieldValues, setFieldValue: function (property, value) {
                                    setFieldValues(inputFieldsContainerHelper.getUpdatedFieldValues(fieldValues, property, value));
                                }, labelFieldNameWidth: "160px", lineHeight: "40px" }), _jsxs(Box, __assign({ className: styles.pricingBox }, { children: [_jsx(InputFieldsContainer, { colDef: priceHeaderCols, fieldValues: {
                                            stdProdPrice: {
                                                value: ((_c = standardProductPrice.body) === null || _c === void 0 ? void 0 : _c.totalListPrice)
                                                    ? "$".concat(Number((_d = standardProductPrice.body) === null || _d === void 0 ? void 0 : _d.totalListPrice).toFixed(2))
                                                    : undefined,
                                                customErrorMsg: ((_e = standardProductPrice.body) === null || _e === void 0 ? void 0 : _e.returnCode) !== 0
                                                    ? (_f = standardProductPrice.body) === null || _f === void 0 ? void 0 : _f.returnMessage
                                                    : undefined,
                                                loading: standardProductPrice.loading,
                                            },
                                            calcProdPrice: {
                                                value: ((_g = calculatedProductPrice.body) === null || _g === void 0 ? void 0 : _g.totalListPrice)
                                                    ? "$".concat(Number((_h = calculatedProductPrice.body) === null || _h === void 0 ? void 0 : _h.totalListPrice).toFixed(2))
                                                    : undefined,
                                                customErrorMsg: ((_j = calculatedProductPrice.body) === null || _j === void 0 ? void 0 : _j.returnCode) !== 0
                                                    ? (_k = calculatedProductPrice.body) === null || _k === void 0 ? void 0 : _k.returnMessage
                                                    : undefined,
                                                loading: calculatedProductPrice.loading,
                                            },
                                        }, labelFieldNameWidth: "160px", lineHeight: "40px" }), _jsx(Typography, __assign({ className: styles.cpaDetailText }, { children: "To view Pricing, Deviations, or Drawings, visit the Custom Product detail page:" })), _jsxs(Box, __assign({ sx: {
                                            display: 'flex',
                                            flexDirection: 'row',
                                            paddingTop: '30px',
                                            justifyContent: 'space-between',
                                        } }, { children: [_jsx(Link, __assign({ to: "/cpa/product/".concat(cpn), target: "_blank", className: "".concat(styles.quickLink) }, { children: "View Custom Product in CPA \u2192" })), _jsx(Link, __assign({ to: "/product-info/info?prefix=".concat(cpn, "&date=").concat(newParsedTimeStamp.parsedDateString, "&time=").concat(newParsedTimeStamp.parsedTimeString, "&channel=Commercial&pid=").concat(productId, "&productVersion=").concat(productVersion, "&origin=advanced"), target: "_blank", className: "".concat(styles.quickLink), style: { marginRight: '75px' } }, { children: "View Custom Product Info \u2192" }))] }))] }))] })), _jsx(PubTable, { def: tableDataDefinition, tableData: featureTableData })] })))] }));
}
var buildFieldValues = function (cpaProduct, cpn) {
    var _a;
    return (_a = {},
        _a[DESCRIPTION_VALUE] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.productName,
        },
        _a[DISCOUNT_CODE_FIELD_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.discountCode,
        },
        _a[PRODUCT_LINE_CODE_FIELD_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.productLineCode,
        },
        _a[STANDARD_PRODUCT_REF_FIELD_NAME] = {
            value: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.standardProductReference,
        },
        _a[CPN_FIELD_NAME] = {
            value: cpn,
        },
        _a);
};
function getCpaProduct(cpn) {
    return __awaiter(this, void 0, void 0, function () {
        var getProductRsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cpaService.getProduct(cpn, false)];
                case 1:
                    getProductRsp = _a.sent();
                    return [2 /*return*/, getProductRsp];
            }
        });
    });
}
